module.exports = __webpack_public_path__ + "img/INF-A-1-I.8ca5f726.png";